export const root = "riu7t25";
export const header = "hoorxj2";
export const ctaBlock = "cff9fqq";
export const ctaButtons = "churuip";
export const ctaButton = "c1gg0gd5";
export const desc = "d185w8j6";
export const videoContainer = "v173yqj8";
export const video = "v1q91d7g";
export const profileLink = "p1lths5b";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");